// this is an autogenerated file from DesignSystem/CheckIn/AssignConnection/Content/Content/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CheckIn_AssignConnection_Content_Content($patient_id: uuid!, $connection_id: uuid!) {
  insert_apps_connection_patients_one(
    object: { patient_id: $patient_id, connection_id: $connection_id }
  ) {
    id
  }
}

`